import { render } from "./Passengers.vue?vue&type=template&id=54b1976f&scoped=true"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"

import "./Passengers.vue?vue&type=style&index=0&id=54b1976f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b1976f"]])

export default __exports__